import { Fab, Paper, ButtonGroup, Button, Tooltip } from "@mui/material";
import SelectAllIcon from "@mui/icons-material/SelectAll";
import "./teethchart.css";
import { useContext, useEffect, useState } from "react";
import { assetsUrl } from "../../../../constants";
import { TeethContextV1, TeethContextType } from "../indexv1";
import TeethSection from "./TeethSection";
import { Tooth } from "./DentalForm/components/Types";
import useAuthentication from "@hooks/useAuthentication";

const tooth11_21 = `${assetsUrl}/Teeth/11_21.png`;
const tooth11_21C = `${assetsUrl}/Teeth/11_21C.png`;
const tooth12_22 = `${assetsUrl}/Teeth/12_22.png`;
const tooth12_22C = `${assetsUrl}/Teeth/12_22C.png`;
const tooth13_23 = `${assetsUrl}/Teeth/13_23.png`;
const tooth13_23C = `${assetsUrl}/Teeth/13_23C.png`;
const tooth14_24 = `${assetsUrl}/Teeth/14_24.png`;
const tooth14_24C = `${assetsUrl}/Teeth/14_24C.png`;
const tooth15_25 = `${assetsUrl}/Teeth/15_25.png`;
const tooth15_25C = `${assetsUrl}/Teeth/15_25C.png`;
const tooth16_26 = `${assetsUrl}/Teeth/16_26.png`;
const tooth16_26C = `${assetsUrl}/Teeth/16_26C.png`;
const tooth17_27 = `${assetsUrl}/Teeth/17_27.png`;
const tooth17_27C = `${assetsUrl}/Teeth/17_27C.png`;
const tooth18_28 = `${assetsUrl}/Teeth/18_28.png`;
const tooth18_28C = `${assetsUrl}/Teeth/18_28C.png`;
const tooth32_42 = `${assetsUrl}/Teeth/32_42.png`;
const tooth32_42C = `${assetsUrl}/Teeth/32_42C.png`;
const tooth34_44 = `${assetsUrl}/Teeth/34_44.png`;
const tooth34_44C = `${assetsUrl}/Teeth/34_44C.png`;
const tooth38_48 = `${assetsUrl}/Teeth/38_48.png`;
const tooth38_48C = `${assetsUrl}/Teeth/38_48C.png`;
const tooth41_31 = `${assetsUrl}/Teeth/41_31.png`;
const tooth41_31C = `${assetsUrl}/Teeth/41_31C.png`;
const tooth43_33 = `${assetsUrl}/Teeth/43_33.png`;
const tooth43_33C = `${assetsUrl}/Teeth/43_33C.png`;
const tooth45_35 = `${assetsUrl}/Teeth/45_35.png`;
const tooth45_35C = `${assetsUrl}/Teeth/45_35C.png`;
const tooth46_36 = `${assetsUrl}/Teeth/46_36.png`;
const tooth46_36C = `${assetsUrl}/Teeth/46_36C.png`;
const tooth47_37 = `${assetsUrl}/Teeth/47_37.png`;
const tooth47_37C = `${assetsUrl}/Teeth/47_37C.png`;

const tooth51 = `${assetsUrl}/Teeth/childTeeth/F51.gif`;
const tooth52 = `${assetsUrl}/Teeth/childTeeth/F52.gif`;
const tooth53 = `${assetsUrl}/Teeth/childTeeth/F53.gif`;
const tooth54 = `${assetsUrl}/Teeth/childTeeth/F54.gif`;
const tooth55 = `${assetsUrl}/Teeth/childTeeth/F55.gif`;
const tooth61 = `${assetsUrl}/Teeth/childTeeth/F61.gif`;
const tooth62 = `${assetsUrl}/Teeth/childTeeth/F62.gif`;
const tooth63 = `${assetsUrl}/Teeth/childTeeth/F63.gif`;
const tooth64 = `${assetsUrl}/Teeth/childTeeth/F64.gif`;
const tooth65 = `${assetsUrl}/Teeth/childTeeth/F65.gif`;
const tooth71 = `${assetsUrl}/Teeth/childTeeth/F71.gif`;
const tooth72 = `${assetsUrl}/Teeth/childTeeth/F72.gif`;
const tooth73 = `${assetsUrl}/Teeth/childTeeth/F73.gif`;
const tooth74 = `${assetsUrl}/Teeth/childTeeth/F74.gif`;
const tooth75 = `${assetsUrl}/Teeth/childTeeth/F75.gif`;
const tooth81 = `${assetsUrl}/Teeth/childTeeth/F81.gif`;
const tooth82 = `${assetsUrl}/Teeth/childTeeth/F82.gif`;
const tooth83 = `${assetsUrl}/Teeth/childTeeth/F83.gif`;
const tooth84 = `${assetsUrl}/Teeth/childTeeth/F84.gif`;
const tooth85 = `${assetsUrl}/Teeth/childTeeth/F85.gif`;

const TeethChart = () => {
  const { user } = useAuthentication();
  const configuredTooth = user?.tooth?.toUpperCase() === 'UNIVERSAL' ? 'Universal' : 'FDI';
  const { selectedTooth, setSelectedTooth, edit } = useContext(
    TeethContextV1,
  ) as TeethContextType;
  const [type, setType] = useState<boolean>(true);
  const handleImageClick = (toothId: any) => {
    const updated = { ...selectedTooth };
    if (selectedTooth[toothId[0]]) {
      delete updated[toothId[0]];
    } else {
      updated[toothId[0] as keyof typeof selectedTooth] = toothId[1];
    }
    setSelectedTooth(updated);
  };

  useEffect(() => {
    if (Object.values(selectedTooth)[0]?.toothNo >= 51) {
      setType(false);
    }
  }, [selectedTooth]);

  useEffect(() => {
    if (!Boolean(edit)) {
      setSelectedTooth({});
    }
  }, [type]);

  const [numberingSystem, setNumberingSystem] = useState<string>(configuredTooth);

  const upperJawUniversal: { [key: string]: Tooth } = {
    teeth1: {
      id: null,
      toothNo: 1,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth18_28,
      image2: tooth18_28C,
    },
    teeth2: {
      id: null,
      toothNo: 2,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth17_27,
      image2: tooth17_27C,
    },
    teeth3: {
      id: null,
      toothNo: 3,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth16_26,
      image2: tooth16_26C,
    },
    teeth4: {
      id: null,
      toothNo: 4,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth15_25,
      image2: tooth15_25C,
    },
    teeth5: {
      id: null,
      toothNo: 5,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth14_24,
      image2: tooth14_24C,
    },
    teeth6: {
      id: null,
      toothNo: 6,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth13_23,
      image2: tooth13_23C,
    },
    teeth7: {
      id: null,
      toothNo: 7,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth12_22,
      image2: tooth12_22C,
    },
    teeth8: {
      id: null,
      toothNo: 8,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth11_21,
      image2: tooth11_21C,
    },
    teeth9: {
      id: null,
      toothNo: 9,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth11_21,
      image2: tooth11_21C,
    },
    teeth10: {
      id: null,
      toothNo: 10,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth12_22,
      image2: tooth12_22C,
    },
    teeth11: {
      id: null,
      toothNo: 11,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth13_23,
      image2: tooth13_23C,
    },
    teeth12: {
      id: null,
      toothNo: 12,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth14_24,
      image2: tooth14_24C,
    },
    teeth13: {
      id: null,
      toothNo: 13,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth15_25,
      image2: tooth15_25C,
    },
    teeth14: {
      id: null,
      toothNo: 14,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth16_26,
      image2: tooth16_26C,
    },
    teeth15: {
      id: null,
      toothNo: 15,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth17_27,
      image2: tooth17_27C,
    },
    teeth16: {
      id: null,
      toothNo: 16,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth18_28,
      image2: tooth18_28C,
    },
  };
  const lowerJawUniversal: { [key: string]: Tooth } = {
    teeth32: {
      id: null,
      toothNo: 32,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth38_48,
      image2: tooth38_48C,
    },
    teeth31: {
      id: null,
      toothNo: 31,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth47_37,
      image2: tooth47_37C,
    },
    teeth30: {
      id: null,
      toothNo: 30,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth46_36,
      image2: tooth46_36C,
    },
    teeth29: {
      id: null,
      toothNo: 29,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth45_35,
      image2: tooth45_35C,
    },
    teeth28: {
      id: null,
      toothNo: 28,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth34_44,
      image2: tooth34_44C,
    },
    teeth27: {
      id: null,
      toothNo: 27,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth43_33,
      image2: tooth43_33C,
    },
    teeth26: {
      id: null,
      toothNo: 26,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth32_42,
      image2: tooth32_42C,
    },
    teeth25: {
      id: null,
      toothNo: 25,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth41_31,
      image2: tooth41_31C,
    },
    teeth24: {
      id: null,
      toothNo: 24,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth41_31,
      image2: tooth41_31C,
    },
    teeth23: {
      id: null,
      toothNo: 23,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth32_42,
      image2: tooth32_42C,
    },
    teeth22: {
      id: null,
      toothNo: 22,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth43_33,
      image2: tooth43_33C,
    },
    teeth21: {
      id: null,
      toothNo: 21,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth34_44,
      image2: tooth34_44C,
    },
    teeth20: {
      id: null,
      toothNo: 20,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth45_35,
      image2: tooth45_35C,
    },
    teeth19: {
      id: null,
      toothNo: 19,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth46_36,
      image2: tooth46_36C,
    },
    teeth18: {
      id: null,
      toothNo: 18,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth47_37,
      image2: tooth47_37C,
    },
    teeth17: {
      id: null,
      toothNo: 17,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth38_48,
      image2: tooth38_48C,
    },
  };
  const upperChildTeeth: { [key: string]: Tooth } = {
    teeth55: {
      id: null,
      toothNo: 55,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth55,
      image2: tooth38_48C,
    },
    teeth54: {
      id: null,
      toothNo: 54,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth54,
      image2: tooth38_48C,
    },
    teeth53: {
      id: null,
      toothNo: 53,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth53,
      image2: tooth38_48C,
    },
    teeth52: {
      id: null,
      toothNo: 52,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth52,
      image2: tooth38_48C,
    },
    teeth51: {
      id: null,
      toothNo: 51,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth51,
      image2: tooth38_48C,
    },
    teeth61: {
      id: null,
      toothNo: 61,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth61,
      image2: tooth38_48C,
    },
    teeth62: {
      id: null,
      toothNo: 62,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth62,
      image2: tooth38_48C,
    },
    teeth63: {
      id: null,
      toothNo: 63,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth63,
      image2: tooth38_48C,
    },
    teeth64: {
      id: null,
      toothNo: 64,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth64,
      image2: tooth38_48C,
    },
    teeth65: {
      id: null,
      toothNo: 65,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth65,
      image2: tooth38_48C,
    },
  };
  const LowerChildTeeth = {
    teeth85: {
      id: null,
      toothNo: 85,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth85,
      image2: tooth38_48C,
    },
    teeth84: {
      id: null,
      toothNo: 84,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth84,
      image2: tooth38_48C,
    },
    teeth83: {
      id: null,
      toothNo: 83,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth83,
      image2: tooth38_48C,
    },
    teeth82: {
      id: null,
      toothNo: 82,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth82,
      image2: tooth38_48C,
    },
    teeth81: {
      id: null,
      toothNo: 81,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth81,
      image2: tooth38_48C,
    },
    teeth71: {
      id: null,
      toothNo: 71,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth71,
      image2: tooth38_48C,
    },
    teeth72: {
      id: null,
      toothNo: 72,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth72,
      image2: tooth38_48C,
    },
    teeth73: {
      id: null,
      toothNo: 73,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth73,
      image2: tooth38_48C,
    },
    teeth74: {
      id: null,
      toothNo: 74,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth74,
      image2: tooth38_48C,
    },
    teeth75: {
      id: null,
      toothNo: 75,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth75,
      image2: tooth38_48C,
    },
  };

  const upperJawFDI: { [key: string]: Tooth } = {
    // Quadrant 1 (Upper Right) - FDI 18 to 11
    teeth18: {
      id: null,
      toothNo: 18,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth18_28,
      image2: tooth18_28C,
    },
    teeth17: {
      id: null,
      toothNo: 17,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth17_27,
      image2: tooth17_27C,
    },
    teeth16: {
      id: null,
      toothNo: 16,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth16_26,
      image2: tooth16_26C,
    },
    teeth15: {
      id: null,
      toothNo: 15,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth15_25,
      image2: tooth15_25C,
    },
    teeth14: {
      id: null,
      toothNo: 14,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth14_24,
      image2: tooth14_24C,
    },
    teeth13: {
      id: null,
      toothNo: 13,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth13_23,
      image2: tooth13_23C,
    },
    teeth12: {
      id: null,
      toothNo: 12,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth12_22,
      image2: tooth12_22C,
    },
    teeth11: {
      id: null,
      toothNo: 11,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth11_21,
      image2: tooth11_21C,
    },

    // Quadrant 2 (Upper Left) - FDI 21 to 28
    teeth21: {
      id: null,
      toothNo: 21,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth11_21,
      image2: tooth11_21C,
    },
    teeth22: {
      id: null,
      toothNo: 22,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth12_22,
      image2: tooth12_22C,
    },
    teeth23: {
      id: null,
      toothNo: 23,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth13_23,
      image2: tooth13_23C,
    },
    teeth24: {
      id: null,
      toothNo: 24,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth14_24,
      image2: tooth14_24C,
    },
    teeth25: {
      id: null,
      toothNo: 25,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth15_25,
      image2: tooth15_25C,
    },
    teeth26: {
      id: null,
      toothNo: 26,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth16_26,
      image2: tooth16_26C,
    },
    teeth27: {
      id: null,
      toothNo: 27,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth17_27,
      image2: tooth17_27C,
    },
    teeth28: {
      id: null,
      toothNo: 28,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth18_28,
      image2: tooth18_28C,
    },
  };

  const lowerJawFDI: { [key: string]: Tooth } = {
    // Quadrant 4 (Lower Right) - FDI 48 to 41
    teeth48: {
      id: null,
      toothNo: 48,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth38_48,
      image2: tooth38_48C,
    },
    teeth47: {
      id: null,
      toothNo: 47,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth47_37,
      image2: tooth47_37C,
    },
    teeth46: {
      id: null,
      toothNo: 46,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth46_36,
      image2: tooth46_36C,
    },
    teeth45: {
      id: null,
      toothNo: 45,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth45_35,
      image2: tooth45_35C,
    },
    teeth44: {
      id: null,
      toothNo: 44,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth34_44,
      image2: tooth34_44C,
    },
    teeth43: {
      id: null,
      toothNo: 43,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth43_33,
      image2: tooth43_33C,
    },
    teeth42: {
      id: null,
      toothNo: 42,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth32_42,
      image2: tooth32_42C,
    },
    teeth41: {
      id: null,
      toothNo: 41,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth41_31,
      image2: tooth41_31C,
    },

    // Quadrant 3 (Lower Left) - FDI 31 to 38
    teeth31: {
      id: null,
      toothNo: 31,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth41_31,
      image2: tooth41_31C,
    },
    teeth32: {
      id: null,
      toothNo: 32,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth32_42,
      image2: tooth32_42C,
    },
    teeth33: {
      id: null,
      toothNo: 33,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth43_33,
      image2: tooth43_33C,
    },
    teeth34: {
      id: null,
      toothNo: 34,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth34_44,
      image2: tooth34_44C,
    },
    teeth35: {
      id: null,
      toothNo: 35,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth45_35,
      image2: tooth45_35C,
    },
    teeth36: {
      id: null,
      toothNo: 36,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth46_36,
      image2: tooth46_36C,
    },
    teeth37: {
      id: null,
      toothNo: 37,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth47_37,
      image2: tooth47_37C,
    },
    teeth38: {
      id: null,
      toothNo: 38,
      section: { l1: false, l2: false, r1: false, r2: false, c: false },
      image1: tooth38_48,
      image2: tooth38_48C,
    },
  };

  const activeUpperJaw =
    numberingSystem === "Universal" ? upperJawUniversal : upperJawFDI;
  const activeLowerJaw =
    numberingSystem === "Universal" ? lowerJawUniversal : lowerJawFDI;

  const selectAll = () => {
    if (Object.keys(selectedTooth).length === 0) {
      if (type) {
        setSelectedTooth({ ...activeUpperJaw, ...activeLowerJaw });
      } else {
        setSelectedTooth({ ...upperChildTeeth, ...LowerChildTeeth });
      }
    } else {
      setSelectedTooth({});
    }
  };

  const modifiedUpperJaw = Object.entries(activeUpperJaw);
  const modifiedLowerJaw = Object.entries(activeLowerJaw);
  return (
    <div className="grid grid-cols-12">
      <div className="col-span-9 flex flex-col">
        {type ? (
          <>
            <div className="teeth-row flex  justify-start ">
              {modifiedUpperJaw.map((tooth) => (
                <div className="flex flex-col">
                  <div
                    onClick={() => handleImageClick(tooth)}
                    className={`w-12 h-40 mx-1 flex flex-col justify-center hover:cursor-pointer rounded-lg ${
                      selectedTooth[tooth[0]] ? "border-2 border-blue-500" : ""
                    }`}
                    key={tooth[1].id}
                  >
                    <img
                      src={tooth[1].image1}
                      style={{ height: "85px", width: "50px" }}
                      alt={`Tooth ${tooth[1].id}`}
                    />
                    {tooth[1].image2 && (
                      <img
                        style={{ height: "40px" }}
                        src={tooth[1].image2}
                        alt={`Tooth ${tooth[1].id} Condition`}
                      />
                    )}
                    <Paper className="bg-slate-100 flex justify-center rounded-2xl">
                      {" "}
                      {tooth[1].toothNo}{" "}
                    </Paper>
                  </div>
                  <div className="ml-2">
                    {" "}
                    <TeethSection id={tooth[1]?.toothNo} />
                  </div>
                </div>
              ))}
            </div>
            <div className="teeth-row flex start">
              {modifiedLowerJaw.map((tooth) => (
                <div className="flex flex-col">
                  <div className="ml-2">
                    {" "}
                    <TeethSection id={tooth[1]?.toothNo} />
                  </div>
                  <div
                    onClick={() => handleImageClick(tooth)}
                    className={`w-12 h-40 mx-1 flex flex-col justify-center hover:cursor-pointer rounded-lg ${
                      selectedTooth[tooth[0]] ? "border-2 border-blue-500" : ""
                    }`}
                    key={tooth[1].id}
                  >
                    <Paper className="bg-slate-100 flex justify-center rounded-2xl">
                      {" "}
                      {tooth[1].toothNo}{" "}
                    </Paper>
                    {tooth[1].image2 && (
                      <img
                        style={{ height: "40px" }}
                        src={tooth[1].image2}
                        alt={`Tooth ${tooth[1].id} Condition`}
                      />
                    )}
                    <img
                      src={tooth[1].image1}
                      style={{ height: "85px", width: "50px" }}
                      alt={`Tooth ${tooth[1].id}`}
                    />
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <div className="flex flex-col justify-center items-center gap-y-4">
            <div className=" w-[400px] flex justify-center items-center gap-x-3 ">
              {Object.entries(upperChildTeeth).map((tooth: any) => (
                <div className="flex flex-col justify-center items-center p-1">
                  <div
                    onClick={() => handleImageClick(tooth)}
                    className={` w-12 h-fit gap-y-2 flex flex-col justify-center hover:cursor-pointer rounded-lg ${
                      selectedTooth[tooth[0]] ? "border-2 border-blue-500" : ""
                    }`}
                    key={tooth[1].id}
                  >
                    <img
                      src={tooth[1].image1}
                      style={{ height: "55px", width: "50px" }}
                      alt={`Tooth ${tooth[1].id}`}
                    />
                    <Paper className="bg-slate-100 flex justify-center rounded-2xl">
                      {" "}
                      {tooth[1].toothNo}{" "}
                    </Paper>
                  </div>
                </div>
              ))}
            </div>
            <div className="w-[400px] flex justify-center items-center gap-x-3 hover:cursor-pointer ">
              {Object.entries(LowerChildTeeth).map((tooth: any) => (
                <div className="flex flex-col justify-center items-center p-1">
                  <div
                    onClick={() => handleImageClick(tooth)}
                    className={` w-12 h-fit gap-y-1 flex flex-col justify-center hover:cursor-pointer rounded-lg ${
                      selectedTooth[tooth[0]] ? "border-2 border-blue-500" : ""
                    }`}
                    key={tooth[1].id}
                  >
                    <Paper className="bg-slate-100 flex justify-center rounded-2xl">
                      {" "}
                      {tooth[1].toothNo}{" "}
                    </Paper>
                    <img
                      src={tooth[1].image1}
                      style={{ height: "55px", width: "50px" }}
                      alt={`Tooth ${tooth[1].id}`}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="col-span-3 h-fit">
        <Paper className="p-3 flex flex-row gap-4 items-center">
          <div className="flex items-center justify-between">
            <Tooltip title="Select all">
              <Fab
                size="small"
                color="secondary"
                aria-label="edit"
                onClick={selectAll}
              >
                <SelectAllIcon />
              </Fab>
            </Tooltip>
          </div>
          <div className="flex flex-row flex-wrap gap-3 mt-2 items-center">
            <ButtonGroup
              variant="outlined"
              color="primary"
              aria-label="Patient Type"
            >
              <Button
                onClick={() => {
                  Object.values(selectedTooth).length == 0 && setType(true);
                }}
                variant={type ? "contained" : "outlined"}
              >
                Adult
              </Button>
              <Button
                onClick={() => {
                  Object.values(selectedTooth).length == 0 && setType(false);
                }}
                variant={type ? "outlined" : "contained"}
              >
                Child
              </Button>
            </ButtonGroup>
            {type && (
              <ButtonGroup
                variant="outlined"
                color="primary"
                aria-label="Numbering System"
              >
                <Button
                  disabled={configuredTooth === "Universal"}
                  onClick={() => {
                    Object.values(selectedTooth).length == 0 &&
                      setNumberingSystem("FDI");
                  }}
                  variant={numberingSystem === "FDI" ? "contained" : "outlined"}
                >
                  FDI
                </Button>
                <Button
                  disabled={configuredTooth === "FDI"}
                  onClick={() => {
                    Object.values(selectedTooth).length == 0 &&
                      setNumberingSystem("Universal");
                  }}
                  variant={
                    numberingSystem === "Universal" ? "contained" : "outlined"
                  }
                >
                  Universal
                </Button>
              </ButtonGroup>
            )}
          </div>
        </Paper>
      </div>
    </div>
  );
};

export default TeethChart;
